var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"box"},[_c('img',{staticClass:"home-bg",attrs:{"width":"210","src":require("../assets/images/home.png"),"alt":""}}),_c('h1',{staticClass:"title"},[_vm._v("欢迎登录RRT-策略管理平台")]),_c('h4',{staticClass:"subtitle"},[_vm._v("COPYRIGHT © "+_vm._s(_vm.thisYear)+" RRT")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }